import { useTranslation, Trans } from "react-i18next";

export const useTranslate = () => {
  const { t } = useTranslation();
  return { t, Trans };
};
